import { AxiosResponse } from "axios";
import { Endpoint } from "./util/contants";
import {
  PromptsGetResponse,
  NodesGetResponse,
} from "./responsePayload/PromptResponse";
import {
  apiGetRequest,
  createPayload,
  apiPostRequest,
  apiPatchRequest,
} from "./util/apiUtils";

export const GetPrompts = async (
  pathVariables: Record<string, any> = {},
  queryParams: Record<string, any> = {}
): Promise<PromptsGetResponse | undefined> => {
  return await apiGetRequest<PromptsGetResponse>(
    Endpoint.Prompt,
    pathVariables,
    queryParams
  );
};

export const PostPrompt = async (
  node_name: string,
  prompt: string
): Promise<AxiosResponse | null> => {
  const basePayload = {
    node_name: node_name,
    prompt: prompt,
  };
  const payload = createPayload(basePayload);
  return await apiPostRequest(Endpoint.Prompt, payload);
};

export const PromptResetToDefault = async (nodeNames: string[]) => {
  const basePayload = {
    node_names: nodeNames,
  };
  const payload = createPayload(basePayload);
  return await apiPostRequest(Endpoint.PromptBathDefaultUpdate, payload);
};

export const PromptPatch = async (
  id: number,
  updatedNodeName?: string,
  updatedPrompt?: string,
  updatedIsActive?: boolean,
  updatedIsDefault?: boolean,
  updatedTag?: string | null
): Promise<AxiosResponse | null> => {
  const basePayload = {
    ...(updatedNodeName && { node_name: updatedNodeName }),
    ...(updatedPrompt && { prompt: updatedPrompt }),
    ...(updatedIsActive && { is_active: updatedIsActive }),
    ...(updatedIsDefault && { is_default: updatedIsDefault }),
    ...(updatedTag !== undefined && { tag: updatedTag }),
  };
  const payload = createPayload(basePayload);
  return await apiPatchRequest(Endpoint.PromptPatch, { id: id }, payload);
};

export const GetNodes = async (
  pathVariables: Record<string, any> = {},
  queryParams: Record<string, any> = {}
): Promise<NodesGetResponse | undefined> => {
  return await apiGetRequest<NodesGetResponse>(
    Endpoint.Node,
    pathVariables,
    queryParams
  );
};

export const NodePatchTemp = async (
  id: number,
  updatedTemp: number
): Promise<AxiosResponse | null> => {
  const basePayload = {
    temperature: updatedTemp,
  };
  const payload = createPayload(basePayload);
  return await apiPatchRequest(Endpoint.NodePatch, { id: id }, payload);
};
